import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';
import { RiArrowLeftLine } from '@remixicon/react';

export interface ButtonIconBackProps {
  variant: 'tertiary' | 'primary' | 'secondary';
  size: 'small' | 'medium';
  isDisabled?: boolean;
  onClick: () => void;
}

export const ButtonIconBack = (props: ButtonIconBackProps) => {
  const { variant, size, isDisabled, onClick } = props;
  return (
    <TooltipTrigger delay={100}>
      <ButtonIcon
        icon={<RiArrowLeftLine />}
        variant={variant}
        size={size}
        onClick={onClick}
        isDisabled={isDisabled ?? false}
      />
      <Tooltip placement="bottom">Back</Tooltip>
    </TooltipTrigger>
  );
};
